import { render, staticRenderFns } from "./SalesTable.pug?vue&type=template&id=74b8b45c&scoped=true&lang=pug&"
import script from "./SalesTable.vue?vue&type=script&lang=js&"
export * from "./SalesTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesTable.scss?vue&type=style&index=0&id=74b8b45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b8b45c",
  null
  
)

export default component.exports